export default __webpack_public_path__ + "static/media/word.5614de0a.png";